import axios from 'axios'
import axiosApi from '@/plugins/axios'
import { Module } from 'vuex'

const metadataModule: Module<any, any> = {
    actions: {
        async getMetadata({ commit }, link) {
            let data = null

            const baseURL = import.meta.env.VITE_META_FETCHER_BASE_URL || ''
            const api = baseURL 
                ? axios.create({
                    baseURL: baseURL,
                    withCredentials: true
                })
                : axiosApi

            await api
                .get('/meta/fetch?url=' +
                        encodeURIComponent(link)
                )
                .then((response) => {
                    data = response.data
                })

            return data
        },
    },
}

export default metadataModule
